import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertsService } from 'app/services/alerts.service';

@Component({
    selector: 'app-manage-alerts',
    templateUrl: './manage-alerts.component.html',
    styleUrls: ['./manage-alerts.scss'],
    standalone: false
})

export class ManageAlertsComponent implements OnInit {
  alerts = [];
  newAlert = false;
  newAlertForm: FormGroup;

  alertTypes = ['info', 'warning'];
  alertScopes = ['public', 'admin'];

  constructor(
    private readonly alertsService: AlertsService,
    private readonly formBuilder: FormBuilder,
    ) {
  }

  ngOnInit() {
    this.getAllAlerts();
    this.initForm();
  }

  getAllAlerts = () => {
    this.alertsService.getAllAlerts().subscribe((res: any) => {
      this.alerts = res;
    })
  }

  createNewAlert() {
    this.newAlert = true;
  }

  initForm() {
    this.newAlertForm = this.formBuilder.group({
      title: ['', [Validators.required, Validators.maxLength(100)]],
      message: ['', [Validators.required, Validators.maxLength(300)]],
      scope: ['', Validators.required],
      type: ['', Validators.required],
      startTime: [null, Validators.required],
      endTime: [null, Validators.required],
    })
  }

  saveAlert() {
    const body = this.newAlertForm.value;
    this.alertsService.createAlert(body).subscribe(res => {
      window.location.reload();
    });
  }

  deleteAlert(alert) {
    this.alertsService.deleteAlert(alert.id).subscribe(res => {
      window.location.reload();
    })
  }

  resetForm() {
    this.newAlertForm.reset();
  }
}
